module.exports = __webpack_public_path__ + "@/assets/img/trend-none.130220cc.svg";